import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';


@Injectable({
  providedIn: 'root'
})
export class GrantsApiService extends ApiService {
  readonly resourcePath = 'grants';

  list(id:string): Observable<HydraCollection<any>> {
    //return this.restList<any>(filters);
    return this.restList<any>({'organisationProfile': id, 'order[name]': 'ASC'});
  }

  statistics(orgId:string, year:number){
    return  this.http.get<any>(this.apiUrl + '/me/organisationProfile/'+orgId + '/grants/statistics/'+year);
  }
}
